import {Component} from "react";
import {Button, message} from "antd";
import { WindowParamContext } from "../../../../library/context/WindowContext";
import {ColumnUnit} from "../../../../library/atomic/unit/ColumnUnit";
import {SizeAttr} from "../../../../library/basic/size";
import {BoxAttr} from "../../../../library/basic/compose";
import {SpanText} from "../../../../library/atomic/text/SpanText";
import {FontAttr} from "../../../../library/basic/font";
import {ModifyInputString} from "./ModifyInput";
import {RowUnit} from "../../../../library/atomic/unit/RowUnit";
import {loginByCode} from "../../../util/account";

export class LoginPanel extends Component {
    static contextType = WindowParamContext;

    state: {
        phone: string,
        password: string,
    } = {
        phone: "",
        password: ""
    }


    componentDidMount() {
    }

    render() {
        return (
            <WindowParamContext.Consumer>
                {wpt => {
                    let wp = wpt.param;

                    return (
                        <ColumnUnit
                            sizeAttr={new SizeAttr(wp, "580px")}
                            customStyleAttr={Object.assign(BoxAttr.getChildrenPositionObj(), {
                                "padding": "42px",
                                "borderRadius": "12px",
                                "border": "1px solid #8a8a8d80"
                            })}
                        >

                            <SpanText
                                fontAttr={new FontAttr(wp, "1.7em", "600")}
                                customStyleAttr={{
                                    "justifyContent": "",
                                    "marginBottom": "40px"
                                }}
                            >
                                {"信风Flow运营管理系统"}
                            </SpanText>


                            {ModifyInputString(wp, "手机号", this.state.phone,
                                (v) => {
                                    this.setState(prevState => (Object.assign(prevState, {phone: v})))
                                }, "", "480px", "36px", "100px", "24px"
                            )}
                            {ModifyInputString(wp, "密码", this.state.password,
                                (v) => {
                                    this.setState(prevState => (Object.assign(prevState, {password: v})))
                                }, "", "480px", "36px", "100px", "24px", "password"
                            )}

                            <RowUnit customStyleAttr={{"marginTop": "16px"}}>
                                <Button
                                    type={"primary"}
                                    style={{
                                        width: "120px"
                                    }}
                                    onClick={() => {
                                        if (this.state.phone == "") {
                                            message.open({
                                                type: 'warning',
                                                content: "请输入账号",
                                            });
                                            return
                                        }
                                        if (this.state.password == "") {
                                            message.open({
                                                type: 'warning',
                                                content: "请输入密码",
                                            });
                                            return
                                        }

                                        loginByCode({
                                            phone: this.state.phone,
                                            code: this.state.password
                                        }, (success, resp) => {
                                            if (success && resp) {
                                                message.open({
                                                    type: 'success',
                                                    content: "登录成功",
                                                });
                                                setTimeout(() => {
                                                    window.location.reload()
                                                }, 200)
                                            } else {
                                                message.open({
                                                    type: 'warning',
                                                    content: "登录失败，请检查账号密码",
                                                });
                                            }
                                        })
                                    }}
                                >
                                    {"登录"}
                                </Button>
                            </RowUnit>

                        </ColumnUnit>
                    )
                }
                }
            </WindowParamContext.Consumer>
        )
    }
}